import { Add } from '@mui/icons-material'

import { ListHeaderActions, ListHeaderPrimaryActionButton } from '@/components/List'
import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { useIsLoading } from '@/atoms'

import { useCanAddNewVehicle } from '../../../../../hooks/useCanAddNewVehicle'

import { useActions } from './hooks/useActions'
import { useTooltipTitle } from './hooks/useTooltipTitle'

export function Actions() {
  const { editing, onCreate } = useActions()
  const isLoading = useIsLoading('fetchGpsData')
  const canAddNewVehicle = useCanAddNewVehicle(isLoading)

  const tooltipTitle = useTooltipTitle({
    editing,
    isLoading,
    canAddNewVehicle,
  })

  return (
    <ReadOnlyTooltip
      forceState="enabled"
      placement="bottom"
      canEdit={canAddNewVehicle}
      title={tooltipTitle}
      render={preventEditing => (
        <ListHeaderActions>
          <ListHeaderPrimaryActionButton
            disabled={preventEditing || editing || !canAddNewVehicle}
            onClick={onCreate}
            trackId="pendo-vehicle__create-new-button"
          >
            <Add />
          </ListHeaderPrimaryActionButton>
        </ListHeaderActions>
      )}
    />
  )
}
